const API_BASE = '/api/public';
const ADMIN_API_BASE = '/api/admin';

export { API_BASE, ADMIN_API_BASE };